import React ,{useEffect,useState} from "react";
import axiosInstance from "../../services/axios";
import axios from "axios";

function MediatorAvatar({debate}){
const [details,setDetails]=useState(false);
const skin_color_obj = {"skin-1":"skin-color-1.png","skin-2":"skin-color-2.png","skin-3":"skin-color-3.png"}
const male_hair_color_obj = {"hair-1":"male-hair-color-1.png","hair-2":"male-hair-color-2.png","hair-3":"male-hair-color-3.png","hair-4":"male-hair-color-4.png"}
const female_hair_color_obj = {"hair-5":"female-hair-color-1.png","hair-6":"female-hair-color-2.png","hair-7":"female-hair-color-3.png","hair-8":"female-hair-color-4.png"}
const dress = {"dress-1":"mediator-clothe-color-1.png","dress-2":"mediator-clothe-color-2.png","dress-3":"mediator-clothe-color-3.png","dress-4":"mediator-clothe-color-4.png"}



useEffect(()=>{

   

    return ()=>{
        try{
            axiosInstance.get(`/details/mediator/${debate.debate_id}/`).then((res)=>{
                setDetails(res.data);
            }).catch((error)=>{
                console.log(error);
            })
        }
        catch(err){
            throw(err)
        }
    
    }
        
},[]);

return(
    <div className="mediator">
        <div className="mediator-avatar">
            {/* <!-- Add/remove className "d-none" when mediator is female --> */}
            {details.gender === "male" ?
            <div className="avatar male">
                <div className="hair">
                    <img src={ process.env.PUBLIC_URL+`img/${male_hair_color_obj[details.hair_color]}` } width="73" alt="" title="" />
                </div>
                <div className="face">
                    <img id="selected_skin" src={ process.env.PUBLIC_URL+`img/${skin_color_obj[details.skin_tone]}` } width="54" alt="" title="" />
                </div>
                <div className="body">
                    <img id="selected_clothe" src={ process.env.PUBLIC_URL+`img/${dress[details.dress_color]}` } width="92" alt="" title="" />
                </div>
            </div>
            :
            <div className="avatar female">
                <div className="hair">
                    <img src={ process.env.PUBLIC_URL+`img/${female_hair_color_obj[details.hair_color]}` } width="73" alt="" title="" />
                </div>
                <div className="face">
                    <img src={ process.env.PUBLIC_URL+`img/${skin_color_obj[details.skin_tone]}` } width="54" alt="" title="" />
                </div>
                <div className="body">
                    <img src={ process.env.PUBLIC_URL+`img/${dress[details.dress_color]}` } width="92" alt="" title="" />
                </div>
            </div>
            }

        </div>
        <hr />
        <div className="name">
            {details.owner ? details.owner.username:""}
            <span>Mediator</span>
        </div>
    </div>
);
}

export default MediatorAvatar;